import { finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable({
  providedIn: 'root'
})
export class BarcodeService {
  http = inject(HttpClient);
  auth = inject(AuthService)
  baseUrl = environment.baseApi
  private authLocalStorageToken = `user`;
  user = this.auth.getUser(this.authLocalStorageToken)
  loadingBar = inject(LoadingBarService)

  constructor() { }

  getBarcodes() {
    this.loadingBar.start()
    return this.http.get(`${this.baseUrl}/barcode-management`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  getPriceTags() {
    this.loadingBar.start()
    return this.http.get(`${this.baseUrl}/price-tags`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  storePriceTags(data: any) {
    this.loadingBar.start()
    return this.http.post(`${this.baseUrl}/price-tags`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  updatePriceTag(id:any, data: any) {
    this.loadingBar.start()
    return this.http.patch(`${this.baseUrl}/price-tags/${id}`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  storeBarcode(data: any) {
    this.loadingBar.start()
    return this.http.post(`${this.baseUrl}/barcode-management/store`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  updateBarcode(id: any, data: any) {
    this.loadingBar.start()
    return this.http.patch(`${this.baseUrl}/barcode-management/update/${id}`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  deleteBarcode(id: any) {
    this.loadingBar.start()
    return this.http.delete(`${this.baseUrl}/barcode-management/delete/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
}
